<app-header></app-header>
<app-leftsidebar></app-leftsidebar>
<main class="success-shell">
<div class="success-page">
  <div class="success-card">
  @if (outcome === 'failed') {
    <span class="success-tick success-tick--failed" aria-hidden="true">
      <svg viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>
    </span>
    <h1>The payment didn't go through</h1>
    <p class="success-lede">It was declined or cancelled, so nothing was charged. Your items are still in your cart.</p>

    <div class="success-actions">
      <a routerLink="/marketplace/checkout" class="wt-btn-primary success-main">Try again</a>
      <a routerLink="/marketplace/cart" class="success-ghost">Back to cart</a>
    </div>
  } @else {
    @if (outcome === 'processing') {
      <span class="success-tick success-tick--waiting" aria-hidden="true">
        <svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="9" /><polyline points="12 7 12 12 15 14" /></svg>
      </span>
      <h1>Almost there</h1>
      <p class="success-lede">We're waiting for your payment to be confirmed. Your files appear in My purchases as soon as it is, usually within a minute.</p>
    } @else {
      <span class="success-tick" aria-hidden="true">
        <svg viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12" /></svg>
      </span>
      <h1>Thank you — you're all set!</h1>
    }
    @if (orderNumber) {
      <p class="success-order">Order <strong>{{ orderNumber }}</strong></p>
    }

    <ol class="success-next">
      <li>
        <span class="success-next-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" /><polyline points="7 10 12 15 17 10" /><line x1="12" y1="15" x2="12" y2="3" /></svg>
        </span>
        <span><strong>Download your files</strong> from My purchases — any time, as often as you like.</span>
      </li>
      <li>
        <span class="success-next-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24"><polygon points="1 6 1 22 8 18 16 22 23 18 23 2 16 6 8 2 1 6" /><line x1="8" y1="2" x2="8" y2="18" /><line x1="16" y1="6" x2="16" y2="22" /></svg>
        </span>
        <span><strong>Use it in your games</strong> — it's also in your Content Vault.</span>
      </li>
      <li>
        <span class="success-next-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" /><polyline points="22,6 12,13 2,6" /></svg>
        </span>
        <span><strong>A receipt is on its way</strong> to your email.</span>
      </li>
    </ol>

    <div class="success-actions">
      <a routerLink="/marketplace/orders" class="wt-btn-primary success-main">
        <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" /><polyline points="7 10 12 15 17 10" /><line x1="12" y1="15" x2="12" y2="3" /></svg>
        Go to My purchases
      </a>
      <a routerLink="/store" class="success-ghost">Keep shopping</a>
    </div>
  }
  </div>
</div>
</main>
<app-footer></app-footer>
